import { createSlice } from '@reduxjs/toolkit';
import { CreditSafePortfolio, CreditSafeReport } from '@dill/dill-shared';
import {
  deleteSavedMonitoringPortfolioExtraReducer,
  getSavedCreditSafeCompaniesExtraReducer,
  getSavedMonitoringPortfoliosExtraReducer,
  updateSavedMonitoringPortfolioExtraReducer,
} from '../reducers/creditReportReducer';

export interface CreditSafePortfolioInitialState {
  loadingList: string[];
  creditMonitoringPortfolios: CreditSafePortfolio[];
  creditMonitoringPortfolio: CreditSafePortfolio | null;
  creditSafeCompanies: CreditSafeReport[];
}

const initialState: CreditSafePortfolioInitialState = {
  loadingList: [],
  creditMonitoringPortfolios: [],
  creditMonitoringPortfolio: null,
  creditSafeCompanies: [],
};

export const creditSafeSlice = createSlice({
  name: 'creditSafe',
  initialState,
  reducers: {
    resetCreditSafeRootState: () => initialState,
  },
  extraReducers(builder) {
    getSavedMonitoringPortfoliosExtraReducer(builder);
    updateSavedMonitoringPortfolioExtraReducer(builder);
    deleteSavedMonitoringPortfolioExtraReducer(builder);
    getSavedCreditSafeCompaniesExtraReducer(builder);
  },
});

export const { resetCreditSafeRootState } = creditSafeSlice.actions;
